import { Component, OnInit ,ViewChild} from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {NgbTimepickerConfig} from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import swal from 'sweetalert2';  
import { DomSanitizer} from '@angular/platform-browser';
import { Pipe, PipeTransform } from '@angular/core'; 
import { connectableObservableDescriptor } from 'rxjs/internal/observable/ConnectableObservable';

import { PdfMakeWrapper,Table,Img} from 'pdfmake-wrapper';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
// importing definitions
import { Txt,Columns,Ul,Ol } from 'pdfmake-wrapper';
import { HttpClient } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';

import { saveAs } from "@progress/kendo-file-saver";
import { exportPDF } from "@progress/kendo-drawing";
import { PDFOptions } from "@progress/kendo-drawing/pdf";
import html2canvas from 'html2canvas';
import jspdf from "jspdf";
import { Table as Table1 } from 'primeng/table';
import * as _ from 'underscore';



@Component({
  selector: 'app-estructura',
  templateUrl: './estructura.component.html',
  styleUrls: ['./estructura.component.scss']
})
export class EstructuraComponent implements OnInit {    
  @ViewChild('clo_pernva',null) clo_pernva;
  @ViewChild('pdf', {static: false}) pdf: any; 
  @ViewChild('dt', {static: false})  dt: Table1;  


  constructor(
    private http: HttpClient,
    public authService: AuthService,
    public sanitizer:DomSanitizer, config: NgbTimepickerConfig,
    private spinner: NgxSpinnerService,
    public router: Router) { }

  ngOnInit() {
    this.ls_area();
    this.get_org();
    this.get_persona();
    this.get_departamento();
    this.ls_competencia();
    
    this.selsiz = { nombre:"Tabloid" };
    this.selori = { nombre:"true", valor:true };
    this.selscale = { nombre: .1 };

    this.margin.push
      ({ 
        top: this.itmmargin.top.toString()+"cm", 
        bottom:this.itmmargin.bottom.toString()+"cm", 
        right:this.itmmargin.right.toString()+"cm", 
        left:this.itmmargin.left.toString()+"cm",
      });
  }
  gda_persona(){}
  test($event){
    var res=JSON.parse($event.cssClass);
    if(res.id_persona==null){        
      swal.fire('¡Puesto sin perfil asignado!', '', 'warning');
    }else{
      localStorage.setItem("perfil",$event.cssClass);
      this.router.navigate(["/perfil"]);
    }      
    return;
  }
  bndmnugral=true;
    oculta_menu(){
      if(this.bndmnugral==true){
        this.bndmnugral=false;
      }else{
        this.bndmnugral=true;
      }
    }
  area;
  txtRole;
  validarole(){
    if(this.exp.posicion==undefined || this.exp.posicion==""){
      return false;
    }
    return true
  }
  nivel1=[];
  nivel2=[];
  nivel3=[];
  ins_role(organo,directo){
   
    if (this.validarole()==false)return ;
    let postData = {
      id_cliente:localStorage.getItem("id_cliente"),
      id_persona: this.exp.id_persona,
      idarea1:0,
      titulo:this.exp.posicion,  
      sufijo:this.exp.sufijo,
      departamento:this.exp.departamento==undefined?"":this.exp.departamento,      
      descripcion:this.exp.descripcion==undefined?"":this.exp.descripcion,       
      organo:'A', 
      directo:0,
      id_departamento:this.exp.id_departamento
    } 
    
    
    this.authService.service("/api/ins_rolecard4",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat); 

          var id = res[0][0].id;
          this.exp.id = id;
          
          this.ls_area();
          //this.limpia_rol();          
        
          var itm = {id : id};
          this.ver_role(itm)          
          setTimeout(() => { 
            this.bndJD=true;
          }, 2000);
          swal.fire({ icon: "success", html: "<h5>Registro generado puede continuar las demás secciones</h5>", showConfirmButton: false, timer: 2000 });          
          //this.clo_pernva.nativeElement.click();
          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! exp', '', 'error');
        });   

  }
  limpia_rol(){
    this.role_n1D="";
    this.role_n1I="";
    this.role_n2D="";
    this.role_n2I="";
    this.role_n3D="";
    this.role_n3I="";    
  }
  add_role(){
    
  }
  ht
  ls_ht(){    
    let postData = {
      id_role:this._rolecard.id
    } 
    this.ht=[];
    
    this.authService.service("/api/get_ht_role",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          for(var i=0;i<res.length;i++){
            this.ht.push({idx:(i+1),nombre:res[i].nombre,id:res[i].id});
          }
          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        }); 
  }
  txtanio=0;
  empresa_="";
  
  del_jcom(itm){
    if(confirm("Confirm to delete this row?")==false)return;
    let postData = {
      id:itm.id
    } 
      
      this.authService.service("/api/del_jcom",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            
              this.ls_jcom(this.hidCvePersona);
                       
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta!', '', 'error');
          });   
  }
  del_we(itm){
    if(confirm("Confirm to delete this row?")==false)return;
    let postData = {
      id:itm.id
    } 
      
      this.authService.service("/api/del_we",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
           
            this.ls_we(this._rolecard.id);
                     
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta!', '', 'error');
          });   
  }
  ins_we(){
    if(this.descipcion_we==undefined || this.descipcion_we=="")return ;
    let postData = {
      id:this.hidCvePersona,
      id_role:this.exp.id,
      descripcion:this.descipcion_we,
      anio:Number(this.txtanio),
      id_persona:0,    
      empresa:""
    } 
      
      this.authService.service("/api/ins_we",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);                      
            this.ls_we(this.hidCvePersona);
            this.descipcion_we="";
            this.txtanio=0;
            this.empresa_="";
                       
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta!', '', 'error');
          });   
  }  
  
  del_cda(itm){
    if(confirm("Confirm to delete this row?")==false)return;
    let postData = {
      id:itm.id
    } 
      //
      this.authService.service("/api/del_cda",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            if (res.length!=0)
            {
              this.ls_cda(this.hidCvePersona);
            }           
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta!', '', 'error');
          });   
  }
  del_kdr(itm){
    if(confirm("Confirm to delete this row?")==false)return;
    let postData = {
      id:itm.id
  
    } 
      //
      this.authService.service("/api/del_kdr",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            if (res.length!=0)
            {
              this.ls_kdr(this.hidCvePersona);
            }           
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta!', '', 'error');
          }); 
  }
  del_kpi(itm){
    if(confirm("Confirm to delete this row?")==false)return;
    let postData = {
      id:itm.id
    } 
      //
      this.authService.service("/api/del_kpi",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            if (res.length!=0)
            {
              this.ls_kpi(this.hidCvePersona);
            }           
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta!', '', 'error');
          }); 
  }
  del_dke(itm){
    if(confirm("Confirm to delete this row?")==false)return;
    let postData = {
      id:itm.id
    } 
      //
      this.authService.service("/api/del_dke",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            if (res.length!=0)
            {
              this.ls_dke(this.hidCvePersona);
            }           
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta!', '', 'error');
          }); 
  }
  ins_cda(){
    if(this.descipcion_cda==undefined || this.descipcion_cda=="")return ;
    let postData = {
      id:this.hidCvePersona,
      id_role:this.exp.id,
      descripcion:this.descipcion_cda
    } 
      //
      this.authService.service("/api/ins_cda",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            if (res.length!=0)
            {
              this.ls_cda(this.hidCvePersona);
              this.descipcion_cda="";
            }           
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta!', '', 'error');
          });   
  }
  descipcion_cda="";
  ins_kdr(){
    if(this.descipcion_kdr==undefined || this.descipcion_kdr=="")return ;
    let postData = {
      id:this.hidCvePersona,
      id_role:this.exp.id,
      descripcion:this.descipcion_kdr
    } 
      //
      this.authService.service("/api/ins_kdr",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            if (res.length!=0)
            {
              this.ls_kdr(this.hidCvePersona);
              this.descipcion_kdr="";
            }           
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta!', '', 'error');
          }); 
  }
  descipcion_kdr="";
  ins_kpi(){
    if(this.descipcion_kpi==undefined || this.descipcion_kpi=="")return ;
    let postData = {
      id:this.hidCvePersona,
      id_role:this.exp.id,
      descripcion:this.descipcion_kpi
    } 
      //
      this.authService.service("/api/ins_kpi",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            if (res.length!=0)
            {
              this.ls_kpi(this.hidCvePersona);
              this.descipcion_kpi="";
            }           
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta!', '', 'error');
          }); 
  }
  descipcion_kpi="";
  descipcion_dke="";
  ins_dke(){
    if(this.descipcion_dke==undefined || this.descipcion_dke=="")return ;
    let postData = {
      id:this.hidCvePersona,
      id_role:this.exp.id,
      descripcion:this.descipcion_dke
    } 
      //
      this.authService.service("/api/ins_dke",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            if (res.length!=0)
            {
              this.ls_dke(this.hidCvePersona);
              this.descipcion_dke="";
            }           
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta!', '', 'error');
          }); 
  }
  are1=true;
  are2=true;
  bndDepa=false;
  migrate=0;
  v_role=false;
  limpia_role(){
    this.bndJD=false;
    this.bndcda=false;
    this.bndkdr=false;
    this.bndkpi=false;
    this.bnddke=false;
    this.bndnr=false;
    this.bnddo=false;
    this.bndphy=false;
    this.bndjcom=false;
    this.bndedu=false;
    this.bndwe=false;
    this.bndws=false;
    
  }
  gda_exp(){
    let postData = {
      id_persona:this.exp.id_persona,
      descripcion:this.exp.descripcion,
      id_role:this._rolecard.id,
      titulo:this.exp.posicion,
      sufijo:this.exp.sufijo,
      departamento:this.exp.departamento==null?"":this.exp.departamento,
      area1:this._mAre1,
      area2:this._mAre2,
      organo:this.exp.organo,
      directo:this.exp.directo,
      id_departamento:this.exp.id_departamento
    } 
    this.loading=true;
      
      this.authService.service("/api/gda_experience_role1",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);  
              this.ls_area();              
              //this._regresa();
              //this.get_reportto(this.hidCvePersona);
              this.loading=false;
              swal.fire('Success ok', '', 'success');
              this.loading=false; 
              
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta! gexp', '', 'error');
              this.loading=false;           
          });   
  }
  bndws=false;
  show__(t){
    if (this.exp.id == 0 && t != "jd" ){
      swal.fire({ icon: "warning", html: "<h5>Para acceder a esta sección primero defina <b style='color:darkblue;'>'Job details'</b>y de click en <b style='color:green;'>'Generar'</b></h5>", showConfirmButton: false, timer: 2000 });
      return;
    }

    switch(t){
      case 'ws':
        if(this.bndws==true){
          this.limpia_role();
        }else{
          this.limpia_role();
          this.bndws=true;
        }
      break;
      case 'nr':
        if(this.bndnr==true){
          this.limpia_role();
        }else{
          this.limpia_role();
          this.bndnr=true;
        }
        break;
      case 'do':
        if(this.bnddo==true){
          this.limpia_role();
        }else{
          this.limpia_role();
          this.bnddo=true;
        }
          break;
      case 'jd':      
        if(this.bndJD==true){
          this.limpia_role();
        }else{
          this.limpia_role();
          this.bndJD=true;
        }
        break;
      case 'cda':
        if(this.bndcda==true){
          this.limpia_role();
        }else{
          this.limpia_role();
          this.bndcda=true;
        }
        break;
      case 'kdr':
        if(this.bndkdr==true){
          this.limpia_role();
        }else{
          this.limpia_role();
          this.bndkdr=true;
        }   
        break;
      case 'kpi':
        if(this.bndkpi==true){
          this.limpia_role();
        }else{
          this.limpia_role();
          this.bndkpi=true;
        }
        break;
      case 'dke':
        if(this.bnddke==true){
          this.limpia_role();
        }else{
          this.limpia_role();
          this.bnddke=true;
        }
        break;
        case 'we':
          if(this.bndwe==true){
            this.limpia_role();
          }else{
            this.limpia_role();
            this.bndwe=true;
          }
        break;
        case 'edu':
          if(this.bndedu==true){
            this.limpia_role();
          }else{
            this.limpia_role();
            this.bndedu=true;
          }
        break;
        case 'jcom':
          if(this.bndjcom==true){
            this.limpia_role();
          }else{
            this.limpia_role();
            this.bndjcom=true;
          }
        break;
        case 'phy':
          if(this.bndphy==true){
            this.limpia_role();
          }else{
            this.limpia_role();
            this.bndphy=true;
          }
        break;
    }
  
  }
  _regresa(){
    this.VentanaFix=false;
  }
  VentanaFix=false;
  ver_role(itm){
    if (itm == null){
      this.role_id=0;
      this.ls_rolecard();
      /*
      setTimeout(() => {        
        this.show__('jd');  
      }, 100);
      */
 
      
    }else{
      this.role_id=itm.id;
      this.ls_rolecard();
      //this.VentanaFix=true;    

    }
    
  }
  onChange_nivel(a,id){
    let postData = {
      nivel:a,
      id:id
    }
    this._rolecard=[];
    this.spinner.show();
    this.authService.service("/api/nivel_role",postData)
  .then(
      data => {
        this.spinner.hide();
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        //swal.fire('Cambio realizado!', '', 'success');
      });

  }
  onChange_organo(a,id){
    let postData = {
      organo:a,
      id:id
    }
    this._rolecard=[];
    this.spinner.show();
    this.authService.service("/api/organo_role",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        //swal.fire('Cambio realizado!', '', 'success');
        this.spinner.hide();
      });

  }
  onChange_directo(a,id){
    let postData = {
      directo:a,
      id:id
    }
    this._rolecard=[];
    this.spinner.show();
    this.authService.service("/api/directo_role",postData)
  .then(
      data => {
        this.spinner.hide();
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        //swal.fire('Cambio realizado!', '', 'success');
      });
  }
  ls_rolecard(){
    this.loading=true;
    let postData = {
      role_id:this.role_id
    }
    this._rolecard=[];
    
    this.authService.service("/api/get_rolecard_id",postData)
  .then(
      data => {
        this.loading = false;

        if (data.length == 0){
          this._rolecard=[];
          this._rolecard= null;

          this.exp={
            id:0,
            organo:0,
            directo:0,
            id_persona:0,
            posicion:"",
            txdirRep1:"",
            txdirRep2:"",
            descripcion:"",
            departamento:"",
            sufijo:"",
            lider:0,
            chart:0,
            id_departamento:0
          }
          this.limpia_role();
          return;
        }        

        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        this._rolecard=data[0];
        this.loading=false;
        this.migrate=1;
        this.v_role=true;
        this._mAre1=0;
        this._mAre2=0;
        this.limpia_role();
        this.bndJD=false;
        this.are1=true;
        this.are2=true;       
        this.exp.id=this._rolecard.id;
        this.exp.id_persona=this._rolecard.id_persona;
        this.exp.posicion=this._rolecard.titulo;
        this.exp.descripcion=this._rolecard.descripcion;
        this.exp.lider=this._rolecard.lider;
       this.exp.sufijo=this._rolecard.sufijo;
        this.exp.directo=this._rolecard.directo;        
        this.exp.organo=this._rolecard.organo;
        
        this._mAre1=this._rolecard.idarea1;
        this._mAre2=this._rolecard.idarea2;
        this.exp.txdirRep1=this._rolecard.txdirRep1;
        this.exp.txdirRep2=this._rolecard.txdirRep2;
        this.exp.departamento=this._rolecard.departamento;
        this.exp.id_departamento = this._rolecard.id_departamento
        this.btnmigrate=false;
        this.msg_rolecard="";
        this.hidCvePersona=this._rolecard.id;
        this.cda=[];
        this.kdr=[];
        this.kpi=[];
        this.dke=[];
        this.get_reportto(this._rolecard.id)
        this.ls_cda(this._rolecard.id);
        this.ls_kdr(this._rolecard.id);
        this.ls_kpi(this._rolecard.id);
        this.ls_dke(this._rolecard.id);
        this.ls_we(this._rolecard.id);
        this.ls_edu(this._rolecard.id);
        this.ls_jcom(this._rolecard.id);
        this.ls_phy(this._rolecard.id);
        this.ls_ht();
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta!', '', 'error');
          this.loading=false;
      });
  }
  rpt_ht(itm){
    localStorage.setItem("t_ht","P");
    localStorage.setItem("id_ht",itm.id);
    this.router.navigate([]).then(result => {  window.open('./fmtht', '_blank'); }); 
  
  }
  org;
  persona;
  departamento;
  get_persona(){
    let postData = {
      id_cliente:localStorage.getItem("id_cliente")
    } 
      //
      this.spinner.show();
      this.authService.service("/api/get_persona_role",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);                            
            this.persona=data;                      
            this.spinner.hide();
          },
          error => {
              this.spinner.hide();
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta!  get_persona_role', '', 'error');
          });   
    
  }

  async get_departamento(){
    let postData = {
      id_cliente:localStorage.getItem("id_cliente")
    } 
      //
      this.spinner.show();
      await this.authService.service("/api/get_departamento_tl",postData)
      .then(
          data => {
            this.spinner.hide();
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            this.departamento=data;   
          },
          error => {
              this.spinner.hide();
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta! get_departamento_tl', '', 'error');
          });   
    
  }

  get_org(){
    let postData = {
      id_cliente:localStorage.getItem("id_cliente")
    } 
      //
      this.spinner.show();
      this.authService.service("/api/get_org_role",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
                this.org=data;
                var bnd=false;
                for(var i=0;i<this.org.length;i++){
                  if(this.org[i].organo=='D' && bnd==false){
                    bnd=true;
                    this.selusu(this.org[i].id_role)
                  }
                }
                this.spinner.hide();
                      
          },
          error => {
              this.spinner.hide();
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta! exp', '', 'error');
          });   
    }
  role_id=0;
  async ls_edu(id_){
    let postData = {id_role:id_} 
    await this.authService.service("/api/get_educacion_role",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
            this.edu=data;
          
          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });  
  }
  async ls_jcom(id_){
    let postData = {id_role:id_} 
    await this.authService.service("/api/get_jcom",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          this.jcom=data;
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });  
  }
  async ls_phy(id_){
    let postData = {id_role:id_} 
    await this.authService.service("/api/get_pdwe_role",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);    
            this.phy=data;          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });  
  }
  async get_experience(id_){
    let postData = {
      id:id_ 
    } 
      //console.log(postData);
     await this.authService.service("/api/get_experience",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);
              //console.log(res[0]);              
              this.exp.id=res[0].id;
              this.exp.posicion=res[0].titulo;
              this.exp.descripcion=res[0].descripcion;
              this._mAre1=res[0].idarea1;
              this._mAre2=res[0].idarea2;
              this.exp.txdirRep1=res[0].txdirRep1;
              this.exp.txdirRep2=res[0].txdirRep2;
                      
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta! exp', '', 'error');
          });   
  }
  txtgrado="";
txtanio_=0;
ins_phy(){
  if(this.descipcion_phy==undefined || this.descipcion_phy=="")return ;
  let postData = {
    id:this.hidCvePersona,
    id_role:this.exp.id,
    des:this.descipcion_phy
  } 
    this.authService.service("/api/ins_pdwe_role",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.ls_phy(this.hidCvePersona);
            this.descipcion_phy="";
          }           
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });   
}
_competencia;
ls_competencia(){    
  let postData = { 
    id_cliente:localStorage.getItem("id_cliente"),
  } 
  this.spinner.show();
  this.authService.service("/api/get_competencia_cliente",postData)
  .then(
      data => {
        this.spinner.hide();
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        this._competencia=res;
        
      },
      error => {
          this.spinner.hide();
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('¡API incorrecta! gdareportto', '', 'error');
      });   
  
}
selComp=0;
del_phy(itm){
  if(confirm("Confirm to delete this row?")==false)return;
  let postData = {
    id:itm.id
  } 
    this.authService.service("/api/del_pdwe",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.ls_phy(this.hidCvePersona);
          }           
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });   
}
ins_jcom(){
  if(this.selComp==undefined || this.selComp==0)return ;
  let postData = {
    id:this.hidCvePersona,
    id_role:this.exp.id,
    id_competencia:this.selComp
  } 
    this.authService.service("/api/ins_jcom",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.ls_jcom(this.hidCvePersona);
            this.descipcion_jcom="";
          }           
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });   
}
del_edu(itm){
  if(confirm("Confirm to delete this row?")==false)return;
  let postData = {
    id:itm.id
  } 
    this.authService.service("/api/del_educacion",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);                         
          this.ls_edu(this.hidCvePersona);                     
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });   
}
ins_edu(){
  if(this.descipcion_edu==undefined || this.descipcion_edu=="")return ;
  let postData = {
    id:this.hidCvePersona,
    id_role:this.exp.id,
    descripcion:this.descipcion_edu,
    anio:0,
    grado:""

  } 
    this.authService.service("/api/ins_edu",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
         
          this.ls_edu(this.hidCvePersona);
          this.descipcion_cda="";
                   
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });   
}
  async ls_we(id_){
    let postData = {id_role:id_} 
    await this.authService.service("/api/get_we_role",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          
          this.we=data;
          
          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });  
  }
  async ls_cda(id_){
    let postData = {id_role:id_} 
    await this.authService.service("/api/get_cda_role",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.cda=data;
          } 
          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });  
  }
  
  async ls_kdr(id_){
    let postData = {id_role:id_  } 
    await this.authService.service("/api/get_kdr_role",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.kdr=data;
          } 
          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });
  }
  async ls_kpi(id_){
    let postData = {id_role:id_ } 
    await this.authService.service("/api/get_kpi_role",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.kpi=data;
          } 
          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });
  }
  
  async ls_dke(id_){
    let postData = { id_role:id_ } 
    await this.authService.service("/api/get_dke_role",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0)
          {
            this.dke=data;
          } 
          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });
  } 
  upd_cda(){
    
    let postData = {id:this.id_cda,descripcion:this.descipcion_cda  } 
    this.authService.service("/api/upd_cda",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat); 
                                 
          for(var i=0;i<this.cda.length;i++){
            if(this.cda[i].id==this.id_cda){
              this.cda[i].descripcion=this.descipcion_cda;
            }
          }
          this.descipcion_cda=""; 
          this.bndeditcda=false;
          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });
  }
  can_cda(){
    this.descipcion_cda=""
    this.bndeditcda=false;
  }
  id_cda=0;  
  edit_cda(itm){
    this.id_cda=itm.id;
    this.descipcion_cda=itm.descripcion;
    this.bndeditcda=true;
  }
  upd_kdr(){
    
    let postData = {id:this.id_kdr,descripcion:this.descipcion_kdr  } 
    this.authService.service("/api/upd_kdr",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);     
          
          for(var i=0;i<this.kdr.length;i++){
            if(this.kdr[i].id==this.id_kdr){
              this.kdr[i].descripcion=this.descipcion_kdr;
            }
          }
          this.bndeditkdr=false;
          this.descipcion_kdr="";                    
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });
  }
  upd_kpi(){
    
    let postData = {id:this.id_kpi,descripcion:this.descipcion_kpi  } 
    this.authService.service("/api/upd_kpi",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          for(var i=0;i<this.kpi.length;i++){
            if(this.kpi[i].id==this.id_kpi){
              this.kpi[i].descripcion=this.descipcion_kpi;
            }
          }
          this.bndeditkpi=false;
          this.descipcion_kpi="";
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });
  }
  upd_dke(){
    
    let postData = {id:this.id_dke,descripcion:this.descipcion_dke  } 
    
    this.authService.service("/api/upd_dke",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          for(var i=0;i<this.dke.length;i++){
            if(this.dke[i].id==this.id_dke){
              this.dke[i].descripcion=this.descipcion_dke;
            }
          }
          this.descipcion_dke="";
          this.bndeditdke=false;
          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });
  }
  upd_we(){    
    let postData = {id:this.id_we,anio:this.txtanio,descripcion:this.descipcion_we  } 
    
    this.authService.service("/api/upd_we",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          for(var i=0;i<this.we.length;i++){
            if(this.we[i].id==this.id_we){
              this.we[i].descripcion=this.descipcion_we;
              this.we[i].anio=this.txtanio;
            }
          }
          this.descipcion_we="";
          this.bndeditwe=false;
          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });
  }
  upd_edu(){    
    let postData = {id:this.id_edu,educacion:this.descipcion_edu  } 
    
    this.authService.service("/api/upd_edu",postData)
    .then(
        data => { 
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          for(var i=0;i<this.edu.length;i++){
            if(this.edu[i].id==this.id_edu){
              this.edu[i].educacion=this.descipcion_edu;
              
            }
          }
          this.descipcion_edu="";
          this.bndeditedu=false;
          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });
  }
  n_are1(){

  }
  gda_are1(){

  }
  can_are1(){

  }
  sel1;
  upd_phy(){
    
    let postData = {id:this.id_phy,descripcion:this.descipcion_phy  } 
    
    this.authService.service("/api/upd_phy",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);         
          for(var i=0;i<this.phy.length;i++){
            if(this.phy[i].id==this.id_phy){
              this.phy[i].descripcion=this.descipcion_phy;
            }
          }
          this.descipcion_phy="";
          this.bndeditphy=false;
          
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta!', '', 'error');
        });
  }
  can_kdr(){
    this.descipcion_kdr=""
    this.bndeditkdr=false;
  }
  can_kpi(){
    this.descipcion_kpi=""
    this.bndeditkpi=false;
  }
  can_dke(){
    this.descipcion_dke=""
    this.bndeditdke=false;
  }
  can_we(){
    this.descipcion_we=""
    this.bndeditwe=false;
  }
  can_edu(){
    this.descipcion_edu=""
    this.bndeditedu=false;
  }
  can_jcom(){
    this.descipcion_jcom=""
    this.bndeditjcom=false;
  }
  can_phy(){
    this.descipcion_phy=""
    this.bndeditphy=false;
  }
  id_kdr=0;
  id_kpi=0;
  id_dke=0;
  id_we=0;
  id_edu=0;
  id_jcom=0;
  id_phy=0;
  edit_kdr(itm){
    this.id_kdr=itm.id;
    this.descipcion_kdr=itm.descripcion;
    this.bndeditkdr=true;
  }
  edit_kpi(itm){
    this.id_kpi=itm.id;
    this.descipcion_kpi=itm.descripcion;
    this.bndeditkpi=true;
  }
  edit_dke(itm){
    this.id_dke=itm.id;
    this.descipcion_dke=itm.descripcion;
    this.bndeditdke=true;
  }
  edit_we(itm){
    
    this.id_we=itm.id;
    this.txtanio=itm.anio;
    this.descipcion_we=itm.descripcion;
    this.bndeditwe=true;
  }
  edit_edu(itm){
    this.id_edu=itm.id;
    this.descipcion_edu=itm.educacion;
    this.bndeditedu=true;
  }
  edit_jcom(itm){
    this.id_jcom=itm.id;
    this.descipcion_jcom=itm.descripcion;
    this.bndeditjcom=true;
  }
  edit_phy(itm){
    this.id_phy=itm.id;
    this.descipcion_phy=itm.descripcion;
    this.bndeditphy=true;
  }
  bndeditcda=false;
  bndeditkdr=false;
  bndeditkpi=false;
  bndeditdke=false;
  bndeditwe=false;
  bndeditedu=false;
  bndeditjcom=false;
  bndeditphy=false;
  cda:any;
  kdr:any;
  kpi:any;
  dke:any; 
  we:any;
  edu:any;
  jcom:any;
  phy:any;
  descipcion_we="";
  descipcion_edu="";
  descipcion_jcom="";
  descipcion_phy="";
  btnmigrate=false;
  msg_rolecard="";
  bndJD:boolean=false;
  bndcda:boolean=false;
  bndkdr:boolean=false;
  bndkpi:boolean=false;
  bnddke:boolean=false;
  bndnr:boolean=false;
  bnddo:boolean=false;
  bndphy:boolean=false;
  bndjcom:boolean=false;
  bndedu:boolean=false;
  bndwe:boolean=false;
  _rolecard;
  _mAre1=0;
  _mAre2=0;
  gda_reportto(){
    this.loading=true;
    let postData = {
      id_persona:this.hidCvePersona,
      id_report:this._mAre2 } 
      //
      this.authService.service("/api/gda_reportto",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            
            this.get_reportto(this.hidCvePersona);                  
            this.loading=false;   
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              this.loading=false;
              swal.fire('¡API incorrecta! gdareportto', '', 'error');
          });   
  
  }
  hidCvePersona;  
  reportto:any;
  get_reportto(cve){
    this.reportto=[];
    let postData = {
      id_persona:cve } 
      this.loading=true;
      this.authService.service("/api/get_reportto",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);                        
            this.reportto=data;
            this.loading=false;           
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              this.loading=false;
              swal.fire('¡API incorrecta! reportto', '', 'error');
          });   
  
  
  }
  exp={
    id:0,
    organo:0,
    directo:0,
    id_persona:0,
    posicion:"",
    txdirRep1:"",
    txdirRep2:"",
    descripcion:"",
    departamento:"",
    sufijo:"",
    lider:0,
    chart:0,
    id_departamento:0
  }
  role_n1D;
  role_n1I;
  role_n2D;
  role_n2I;
  role_n3D;
  role_n3I;
  eli_role(itm){
    if(confirm("Confirm to delete this row?")==false)return;
    let postData = {
      id:itm.id
    }
    this.authService.service("/api/eli_role",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);                     
        this.ls_area()
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta!', '', 'error');
      });  

  }
  onChange_lider(id){
    let postData={
      id_role:id,
      id_cliente:localStorage.getItem("id_cliente")
    }
    this.spinner.show();
    this.authService.service("/api/lider",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);                     
        this.ls_area()       
        this.spinner.hide();         
        swal.fire({ icon: "success", html: "<h3>Información registrada</h3><h5>Finalizando, favor espere...</h5>", showConfirmButton: false, timer: 1000 });                            
      },
      error => {
          this.spinner.hide();         
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta!', '', 'error');
      });  

    for(var i=0;i<this.nivel3.length;i++){
      this.nivel3[i].lider=0;
      if(this.nivel3[i].id==id){
        this.nivel3[i].lider=1;
      }
    }
  }
  value_radio(d,c){
    if(d==c){
      return true;
    }
    else return false;

  }
  organo_="";
  nivel_=-1;
  directo_=0;
  oD=false;
  oP=false;
  oA=false;
  _oD=false;
  _oI=false;
  depend_id=0;
  bus_persona(){
    this.nivel3=this.area;
    var _per=[];
      
    for(var i=0;i<this.nivel3.length;i++){
      var bndpush=false
      if(this.depend_id>0 && this.organo_!="" && this.nivel_>0 && this.directo_>=0){
            if( this.organo_==this.nivel3[i].organo && 
                this.nivel3[i].idarea1==this.depend_id && 
                this.nivel_==this.nivel3[i].nivel &&
                this.directo_==this.nivel3[i].directo ){
                bndpush=true;            
            }
      }else if(this.depend_id>0 && this.organo_!="" && this.nivel_>0 ){
        if(this.nivel3[i].idarea1==this.depend_id &&  this.organo_==this.nivel3[i].organo &&  this.nivel_==this.nivel3[i].nivel ){
          bndpush=true;            
      }
      }else if(this.depend_id>0 && this.organo_!=""){
        if(this.nivel3[i].idarea1==this.depend_id &&  this.organo_==this.nivel3[i].organo  ){
          bndpush=true;            
      }
      }else if(this.depend_id>0){
        if(this.nivel3[i].idarea1==this.depend_id ){
          bndpush=true;            
        }
      }else if(this.depend_id>0 && this.directo_>0){
        if( this.nivel3[i].idarea1==this.depend_id  && this.directo_==this.nivel3[i].directo){
          bndpush=true;            
        }
      }
      if(bndpush)_per.push(this.nivel3[i]);
    
      /*
        if(this.depend_id>0){
          if(this.nivel3[i].idarea1==this.depend_id){            
            if(this.oD==this.nivel3[i].organo){_per.push(this.nivel3[i]);
            }else{
              _per.push(this.nivel3[i]);
            } 
          }
        }else{
          if(this.oD==this.nivel3[i].organo ){
            if(this._oD==this.nivel3[i].directo ){
              _per.push(this.nivel3[i]);
            }else{
              _per.push(this.nivel3[i]);
              
            }
          }else{
            _per.push(this.nivel3[i]);
          }
        }*/
     
            
      
                
    }    
    if (_per.length > 0){
      this.nivel3=_per;
    }    
  }

 
  nvo_role(){
    this.exp.posicion="";
    this.exp.departamento="";
    this.exp.descripcion="";
    this.exp.sufijo="";
    this.exp.id_departamento = 0;
  }
  bus_role(){
    //this.nivel3=this.area;
    var _per=[];
    var n3 = this.area;
    for(var i=0;i<n3.length;i++){
      if( n3[i].area.toLowerCase().includes(this.role_n3D.toLowerCase())){
            _per.push(n3[i]);
      }          
    }    
    if (_per.length > 0){
      this.nivel3=_per;
    }   
  }
  bndfilter=0;
  vfilter(){
    if(this.bndfilter==0){
      this.bndfilter=1;
    }else{
      this.bndfilter=0;
    }
  }
  limpia_nombre(n){
    this.role_n2D="";
    this.role_n2I="";
    this.role_n3D="";
    this.nivel3=[];
    for(var i=0;i<this.area.length;i++){      
        this.nivel3.push(this.area[i]);  
    }
  }
  nivel4=[];
  org_aux;
  opt:any="vertical";
  nodes:any;
  get_nodes(id){      
    var child:any=[];
    var aux=[];
    for(var x=0;x<this.org_aux.length;x++){
      if (this.org_aux[x].idarea1==id){
        var foto_="";
        try {
            if (this.org_aux[x].foto.length>0){
            foto_="https://hoshinup.garocedev.com:3007/"+this.org_aux[x].foto;            
          }else{
            foto_="https://hoshinup.garocedev.com:3007/image-none.jpg";
          }
        } catch (error) {
          foto_="https://hoshinup.garocedev.com:3007/image-none.jpg";
        }
        var name=this.org_aux[x].role_card
        var css='{"id_persona":'+this.org_aux[x].id+',"id_role":'+this.org_aux[x].id_role+'}'
        var title=this.org_aux[x].persona
        var id_role=this.org_aux[x].id_role
        //this.org_aux.splice(x, 1);

        child.push({
          image: foto_,
          name:name,
          cssClass:css,
          title:title,
          childs:this.get_nodes(id_role)
        });
        
      }
        
    }
    return child;
  }

  
  selusu(id){
    this.org_aux=this.org;
    for(let i=0;i<this.org.length;i++){
      if(this.org[i].id_role==id){
        var foto_="";
        if (this.org[i].foto==""){
          foto_="https://hoshinup.garocedev.com:3007/"+this.org[i].foto;            
        }else{
          foto_="https://hoshinup.garocedev.com:3007/image-none.jpg";
        }
        var name=this.org[i].role_card
        var css='{"id_persona":'+this.org[i].id+',"id_role":'+this.org[i].id_role+'}'
        var title=this.org[i].persona
        var id_persona=this.org[i].persona
        var id_role=this.org[i].id_role
    
        //this.org_aux.splice(i, 1);
        
          this.nodes=[{
          name:name,
          cssClass:css,
          image:foto_,
          title:title, 
          childs:this.get_nodes(id_role)
          }];
          
      }
    }
  }
  id_role;
  
  onChange_depend(val,id){
    let postData = {
      id:id,
      val:val
    }
    this.spinner.show();
    this.authService.service("/api/depend_role",postData)
    .then(
      data => {
        this.spinner.hide();
        for(var i=0;i<this.area.length;i++){
          if(this.area[i].id==id){
            this.area[i].idarea1=val;
            
          }
        }
        for(var i=0;i<this.nivel3.length;i++){
          if(this.nivel3[i].id==id){
            this.nivel3[i].idarea1=val;
            
          }
        }
        
        swal.fire({ icon: "success", html: "<h3>Información registrada</h3><h5>Finalizando, favor espere...</h5>", showConfirmButton: false, timer: 1000 });                            
        
      });
  }
  _go(a){
    //localStorage.setItem("menu_","1");    
    this.router.navigate([a]);
  }

  
  ls_area(){
    this.nivel3=[];
    let postData = {
      id_cliente:localStorage.getItem("id_cliente")
    }
    this.spinner.show();
    this.authService.service("/api/get_role2",postData)
    .then(
      data => {
        this.spinner.hide();
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);                     
        this.area=data;

        /*
        var _arr = [];
        for (let i = 0 ; i < data.length; i++){
          _arr.push({
            area: data[i].area,
            chart: data[i].chart,
            departamento: data[i].departamento,
            descripcion: data[i].descripcion,
            directo: data[i].directo,
            estatus: data[i].estatus,
            id: data[i].id,
            id_cliente: data[i].id_cliente,
            id_departamento: data[i].id_departamento,
            id_persona: data[i].id_persona,
            idarea1: data[i].idarea1,
            idarea2: data[i].idarea2,
            idarea3: data[i].idarea3,
            idx: data[i].idx,
            lider: data[i].lider,
            nivel: data[i].nivel,
            organo: data[i].organo,
            pg: data[i].pg,
            sufijo: data[i].sufijo,
            titulo: data[i].titulo,

            area1: {Assembly: data[i].area }, 
          });
        }
        this.area=_arr;
        */

        for(var i=0;i<this.area.length;i++){
          var idx=0;
            if(this.area[i].lider==1)idx=1;
            else if( this.area[i].organo=='D' || this.area[i].directo==1)idx=2;
            else if( this.area[i].organo=='D' || this.area[i].directo==0)idx=3;
            else if( this.area[i].organo=='P' || this.area[i].directo==1)idx=4;
            else if( this.area[i].organo=='P' || this.area[i].directo==0)idx=5;
            else if( this.area[i].organo=='A' || this.area[i].directo==1)idx=6;
            else if( this.area[i].organo=='A' || this.area[i].directo==0)idx=7;
            else idx=8;
            this.area[i].idx=idx;
            this.nivel3.push(this.area[i]);
        } 

        //Filtros
        //Filtros

        this.nivel3.sort((a,b) => 
          a.idx.toString().localeCompare(b.idx.toString()) 
        ); 
        
        
        this.bus_persona();            
        this.bus_role();    
        this.spinner.hide();
      },
      error => {
          this.spinner.hide();
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          swal.fire('API incorrecta!', '', 'error');
      });  
  }

  bndeditdep:boolean = false;
  departamento_edi = "";
  ls_departamentos(){
    this.id_departamento = 0;
    this.bndeditdep = false;
    this.departamento_edi = "";
    this.get_departamento();    
  }

  insupd_departamento(){
    if(this.departamento_edi==undefined || this.departamento_edi=="")return ;
    let postData = {
      id:this.id_departamento,
      departamento:this.departamento_edi,
      id_cliente:localStorage.getItem("id_cliente"),
      estatus:"A"
    } 
      //
      this.authService.service("/api/insupd_departamento",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            if (res.length!=0)
            {
              this.ls_departamentos();
              this.descipcion_cda="";
            }           
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta!', '', 'error');
          });   
  }

  id_departamento=0;  
  edit_departamento(itm){
    this.id_departamento=itm.id;
    this.departamento_edi=itm.departamento;
    this.bndeditdep=true;
  }
  can_editdepartamento(){
    this.departamento_edi=""
    this.bndeditdep=false;
  }
  del_departamento(itm){    
    if(confirm("Confirm to delete this row?")==false)return;
    let postData = {
      id:itm.id
    }       
      this.authService.service("/api/del_departamento",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);              
            this.get_departamento();            
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta!', '', 'error');
          });   
  }

  itm = {
    area: "",
    chart: 0,
    departamento: "",
    descripcion: "",
    directo: 0,
    estatus: "",
    id: 0,
    id_cliente: 0,
    id_departamento: 0,
    id_persona: 0,
    idarea1: 0,
    idarea2: 0,
    idarea3: 0,
    idx: 0,
    lider: 0,
    nivel: 0,
    organo: "",
    pg: 0,
    sufijo: "",
    titulo: "",
  }

  getBase64ImageFromURL(url) {
    return new Promise((resolve, reject) => {
      var img = new Image();
      img.setAttribute("crossOrigin", "anonymous");
    
      img.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
    
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
    
        var dataURL = canvas.toDataURL("image/png");
    
        resolve(dataURL);
      };
    
      img.onerror = error => {
        reject(error);
      };
    
      img.src = url;
    });
    }
    
    

  loading: boolean = false;
  async ls_pdf(itm){

    var sReportto="";
    var sReportto=this.exp.txdirRep1;
    

    this.loading = true;
    this.itm = {
      area: itm.area,
      chart: itm.chart,
      departamento: itm.departamento,
      descripcion: itm.descripcion,
      directo: itm.directo,
      estatus: itm.estatus,
      id: itm.id,
      id_cliente: itm.id_cliente,
      id_departamento: itm.id_departamento,
      id_persona: itm.id_persona,
      idarea1: itm.idarea1,
      idarea2: itm.idarea2,
      idarea3: itm.idarea3,
      idx: itm.idx,
      lider: itm.lider,
      nivel: itm.nivel,
      organo: itm.organo,
      pg: itm.pg,
      sufijo: itm.sufijo,
      titulo: itm.titulo,
    }

    
    await this.ls_cda(itm.id);    
    await this.ls_kdr(itm.id);
    await this.ls_kpi(itm.id);
    await this.ls_dke(itm.id);
    await this.ls_we(itm.id);
    await this.ls_edu(itm.id);
    await this.ls_jcom(itm.id);    
    await this.ls_phy(itm.id);
    await this.get_experience(itm.id_persona);
        
    var vCol1 =  Array();    
    var vCol2 =  Array();    

    
    vCol1.push({ 
        table: {
          widths: ['*'],
          body: [              
              [{ text: 'Job details', bold: true, color: 'darkblue',  border: [false, false, false, true],alignment:'left' }],
          ]
        },
    });
    
    vCol1.push({
      text: [  
        { text: '• ', fontSize: 10 , bold: true, color: 'darkblue'},
        { text: 'Reports to: ', fontSize: 9 , bold: true, color: 'darkblue'},
        { text: sReportto, fontSize: 8 , alignment:'left'}            
      ]
    });
    vCol1.push({
      text: [       
      { text: '• ', fontSize: 10 , bold: true, color: 'darkblue'},
      { text: 'Direct reports: ', fontSize: 9 , bold: true, color: 'darkblue'},
      { text: itm.departamento, fontSize: 8 , alignment:'left'}
      ]
    });
    vCol1.push({
      text: [      
      { text: '• ', fontSize: 10 , bold: true, color: 'darkblue'},
      { text: 'Description: ', fontSize: 9 , bold: true, color: 'darkblue'},
      { text: itm.descripcion, fontSize: 8 , alignment:'justify'}
      ]
    });
    
    //CDA    
    vCol1.push({ 
        table: {
          widths: ['*'],
          body: [
              [{ text: 'Critical deliverables / accountabilities', bold: true, color: 'darkblue',  border: [false, false, false, true],alignment:'left' }],
          ]
        },
    });

    for (let i = 0; i<this.cda.length; i++){
      vCol1.push({
        text: [       
          { text: '• ', fontSize: 10 , bold: true},
          { text: this.cda[i].descripcion, fontSize: 8 , alignment:'justify'}            
        ]
      });      
    }


    //KDR     
    vCol1.push({ 
        table: {
          widths: ['*'],
          body: [
              [{ text: 'Key decision rights', bold: true, color: 'darkblue',  border: [false, false, false, true],alignment:'left' }],
          ]
        },
    });

    for (let i = 0; i<this.kdr.length; i++){
      vCol1.push({
        text: [       
          { text: '• ', fontSize: 10 , bold: true},
          { text: this.kdr[i].descripcion, fontSize: 8 , alignment:'justify'}            
        ]
      });      
    }

    //KPI     
    vCol1.push({ 
        table: {
          widths: ['*'],
          body: [
              [{ text: 'Key performance indicators', bold: true, color: 'darkblue',  border: [false, false, false, true],alignment:'left' }],
          ]
        },
    });

    for (let i = 0; i<this.kpi.length; i++){
      vCol1.push({
        text: [       
          { text: '• ', fontSize: 10 , bold: true},
          { text: this.kpi[i].descripcion, fontSize: 8 , alignment:'justify'}            
        ]
      });      
    }

    //DKE     
    vCol2.push({ 
        table: {
          widths: ['*'],
          body: [
              [{ text: 'Desired knowledge and experience', bold: true, color: 'darkblue',  border: [false, false, false, true],alignment:'left' }],
          ]
        },
    });

    for (let i = 0; i<this.dke.length; i++){
      vCol2.push({
        text: [       
          { text: '• ', fontSize: 10 , bold: true},
          { text: this.dke[i].descripcion, fontSize: 8 , alignment:'justify'}            
        ]
      });      
    }


    //WE     
    vCol2.push({ 
        table: {
          widths: ['*'],
          body: [
              [{ text: 'Work experience', bold: true, color: 'darkblue',  border: [false, false, false, true],alignment:'left' }],
          ]
        },
    });

    for (let i = 0; i<this.we.length; i++){
      vCol2.push({
        text: [       
          { text: '• ', fontSize: 10 , bold: true},
          { text: this.we[i].descripcion, fontSize: 8 , alignment:'justify'}            
        ]
      });      
    }

    //EDU
    vCol2.push({ 
        table: {
          widths: ['*'],
          body: [
              [{ text: 'Education', bold: true, color: 'darkblue',  border: [false, false, false, true],alignment:'left' }],
          ]
        },
    });

    for (let i = 0; i<this.edu.length; i++){
      vCol2.push({
        text: [       
          { text: '• ', fontSize: 10 , bold: true},
          { text: this.edu[i].educacion, fontSize: 8 , alignment:'justify'}            
        ]
      });      
    }

    //JCOM
    vCol2.push({ 
        table: {
          widths: ['*'],
          body: [
              [{ text: 'Job Competences', bold: true, color: 'darkblue',  border: [false, false, false, true],alignment:'left' }],
          ]
        },
    });

    for (let i = 0; i<this.jcom.length; i++){
      vCol2.push({
        text: [       
          { text: '• ', fontSize: 10 , bold: true},
          { text: this.jcom[i].competencia, fontSize: 8 , alignment:'justify'}            
        ]
      });      
    }


    //PHY
    vCol2.push({ 
        table: {
          widths: ['*'],
          body: [
              [{ text: 'PHYSICAL DEMANDS AND WORK ENVIRONMENT', bold: true, color: 'darkblue',  border: [false, false, false, true],alignment:'left' }],
          ]
        },
    });

    for (let i = 0; i<this.phy.length; i++){
      vCol2.push({
        text: [       
          { text: '• ', fontSize: 10 , bold: true},
          { text: this.phy[i].descripcion, fontSize: 8 , alignment:'justify'}            
        ]
      });      
    }
    


    const pdf = new PdfMakeWrapper();      
    pdf.pageSize('letter');    
    pdf.pageOrientation("landscape");   
    pdf.pageMargins([20, 50, 20, 50]);  



    var header = (pagenumber: number, pagecount: number) => {return {alignment:"center",fontSize:12, margin: [15,15],
    
    table: {
      widths: [630,100],
      body: [
          [
            {text: "Position title: " + this.itm.area ,alignment:'left', bold: true, color: '#000', fillColor:'#fff', border: [false, false, false, false]},
            {        
              table: {
                  widths: [100],
                  body: [
                      [{ text: 'WORKING DRAFT', bold: true , border: [true, false, false, true],alignment:'right', }],
                  ]
              }, border: [false, false, false, false]
            },
          ],
          
      ]
    }
    }; };
    pdf.header(header);
    

    pdf.add(new Table([
      
      [
        vCol1,
        {},
        vCol2,
      ]
    ])
    .layout("noBorders").widths([360,10,360]).fontSize(9).end);  

   
    var ima = await this.getBase64ImageFromURL("assets/trinity-footer1.png");
    var footer = (pagenumber: number, pagecount: number) => {return {alignment:"center",fontSize:12, margin: [15,0],
    
    table: {
      widths: [680,'*'],
      body: [
          [
            {image: ima , width: 680, height: 30, border: [false, false, false, false]},
            {text: pagenumber + ' de ' + pagecount, border: [false, false, false, false]}
          ],
          
      ]
    }


    }; };
    pdf.footer(footer);

    this.loading = false;
    pdf.create().open();    
  }

  snombre = "hola"
  winprepdf:boolean = false;

  siz; selsiz;
  ori; selori;
  scale; selscale;
  itmmargin = { top:1, bottom:1, right:1, left:1, };
  margin = [];

  ls_prevpdf(){
    this.winprepdf = true;
    var siz = [];
    siz.push({  nombre:"Letter" });
    siz.push({  nombre:"Executive" });
    siz.push({  nombre:"Legal" });
    siz.push({  nombre:"Tabloid" });    
    this.siz = siz;

    var ori = [];
    ori.push({  nombre:"true", valor:true });
    ori.push({  nombre:"false", valor:false });
    this.ori = ori;

    var scale = [];
    scale.push({  nombre:.1  });
    scale.push({  nombre:.2  });
    scale.push({  nombre:.3  });
    scale.push({  nombre:.4  });
    scale.push({  nombre:.5  });
    scale.push({  nombre:.6  });
    scale.push({  nombre:.7  });
    scale.push({  nombre:.8  });
    scale.push({  nombre:.9  });
    scale.push({  nombre:1  });      
    this.scale = scale;
  }

  ls_pdfSave(){
    this.loading= true;
    this.margin = [];
    this.margin.push
    ({ 
      top: this.itmmargin.top.toString()+"cm", 
      bottom:this.itmmargin.bottom.toString()+"cm", 
      right:this.itmmargin.right.toString()+"cm", 
      left:this.itmmargin.left.toString()+"cm",
    });

    setTimeout(() => { 
      this.pdf.saveAs("chart_"+ + new Date().getTime() + ".pdf");   
      this.loading= false;
    }, 1000);
  }

  imgWidth = 110;
  position = 5;
  left = 50;    
  chart(id){
    this.selusu(id)
  }


  ls_prevpdfN(){
    this.winprepdf = true;
  }

  public captureScreen() {
    this.loading= true;
    var data = document.getElementById("contentToConvert");
    html2canvas(data).then(canvas => {
      // Few necessary setting options
      var imgWidth = this.imgWidth;
      var pageHeight = 80;
      var imgHeight = (canvas.height * imgWidth) / canvas.width;
      var heightLeft = imgHeight;

      const contentDataURL = canvas.toDataURL("image/png");
      let pdf = new jspdf("p", "mm", "a4"); // A4 size page of PDF
      var position = this.position;
      pdf.addImage(contentDataURL, "PNG", this.left, position, imgWidth, imgHeight);
      setTimeout(() => { 
        pdf.save("chart_"+ + new Date().getTime() + ".pdf");             
        this.loading= false;
      }, 1000);
    });
  }

  modulo_comp(){
    //this.router.navigate([]).then(result => {  window.open('./#/competences', '_blank'); })
    //this.router.navigate(["/competences"]); 
    this.router.navigate(
      ['/competences'],
      { queryParams: { caller: 'estructura' } }
    );
  }

}
